import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Card, CardContent, Switch } from '@mui/material';
import { Page, Header } from 'components';
import ReportsKpisDialogForm from './components/ReportsKpisDialogForm';
import Downloads from './components/Downloads';
import ClusterInfo from './components/ClusterInfo';
import Vmo2Report from './components/Vmo2Report';

import {
	SetFormState, GetClustersNames
} from '../actions/ReportsKpisActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const ReportsKpisOps = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.reportsKpisReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const clustersNames = useSelector((state) => state.reportsKpisReducer.clustersNames);

	useEffect(() => {
	
	}, []);

	return (
		<Page className={classes.root} title="Reports Kpis">
			<Header module="Modules" view="Reports Kpis" />
			<Grid className={classes.container} container spacing={1}>
				<Grid item lg={12} xs={12}>
					<ReportsKpisDialogForm />
					{formState.values.searchType !== undefined ? <ClusterInfo /> : null}
					<Downloads />
				</Grid>
			</Grid>
		</Page>
	);
};

export default ReportsKpisOps;
